(function () {
  'use strict';

  angular.module('app.behavior-analytics.teacher-details', []);

})();
